<template>
  <div>
    <div class="flex flex-align-center flex-wrap">
      <div class="flex flex-align-center margin-right-10">
        <div class="keyLabel">关键字：</div>
        <el-input v-model="keywords" style="width:220px" placeholder="商品名称" size="mini"></el-input>
      </div>
      <el-button type="primary" size="mini" @click="currentPage=1,gettablelist()">搜索</el-button>
      <el-button size="mini" @click="gettablelist">刷新</el-button>
    </div>
    <div class="margin-top-10">
      <el-table :data="tablelist" v-loading="tableloading" @row-click="handleRowClick" row-key="Id">
        <el-table-column width="40px">
          <template slot-scope="scope">
            <el-checkbox :value="scope.row.checked"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="" label="商品" min-width="150">
          <template slot-scope="scope">
            <div class="flex flex-align-center">
              <img :src="scope.row.ImgUrlComplete" style="width:64px;height:64px;margin-right:10px" alt="">
              <div>
                <div >{{scope.row.ProductName}}</div>
                <div class="font-12 ellipsis" style="color:#999999FF">{{scope.row.ProductNo}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="活动时间">
          <template slot-scope="scope">
            <div>
              <div>{{scope.row.StartTime}}至{{scope.row.EndTime}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="活动状态" width="150">
          <template slot-scope="scope">
            <div>
              {{scope.row.State==0?'未开始':(scope.row.State==1?'进行中':'已结束')}}
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="flexRow" style="justify-content: center;">
            暂无数据，<el-button type="text" @click="topage">点击此处前往添加</el-button>
          </div>
        </template>
      </el-table>
    </div>
    <div class="margin-top-10 pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pagesize"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  activityHelpProactivityHelpProPageInit,
} from "@/api/sv3.0.0"
import config from "@/config"
export default {
  data () {
    return {
      keywords:'',
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pagesize:10,
      total:0,
      toUrl:config.GO_URL
    }
  },
  mounted () {
    this.gettablelist()
  },
  methods: {
    topage(){
			let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
      let url = this.toUrl + headsUrls +  '/market/helpPro'
      window.open(url)
    },  
    handleRowClick(row, event, column){
			this.tablelist = this.tablelist.map(item=>{
				item.checked = item.ActivityFullId == row.ActivityFullId;
				return item;
			})
			this.$emit('change', {data:row, type:'helpPro', text: row.ProductName})
		},
    handleSizeChange(e){
      this.currentPage = 1
      this.pagesize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywrods:this.keywords,
          Skip:(this.currentPage-1)*this.pagesize,
          Take:this.pagesize,
        }
        let res = await activityHelpProactivityHelpProPageInit(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.checked = false
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
}
</script>

<style lang='less' scoped>

    .pagination{
        flex: 0 0 auto;
    }
</style>